import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { Context } from "../GlobalContext";
import "../global/pages.css";

const Separator = ({ match }) => {
  const { token, surveyList } = useContext(Context);

  const prevSurveyType = useMemo(
    () => match.params.surveyType,
    [match.params.surveyType]
  );

  const prevSurveyNumber = useMemo(
    () => parseInt(match.params.surveyNumber),
    [match.params.surveyNumber]
  );

  const prevTopicNumber = useMemo(
    () => surveyList[prevSurveyNumber].topics.length - 1,
    [surveyList, prevSurveyNumber]
  );

  const prevScreenNumber = useMemo(
    () =>
      surveyList[prevSurveyNumber].topics[prevTopicNumber].screens.length - 1,
    [surveyList, prevTopicNumber, prevSurveyNumber]
  );

  const nextSurveyType = useMemo(
    () =>
      surveyList[prevSurveyNumber + 1].surveyType === "아동척도"
        ? "a"
        : surveyList[prevSurveyNumber + 1].surveyType === "영향평가"
        ? "b"
        : "c",
    [surveyList, prevSurveyNumber]
  );

  return (
    <div
      className="container"
      id="separator__container"
      style={{ textAlign: "center" }}
    >
      {/* {surveyList[prevSurveyNumber].name}가 끝났습니다.
      <br /> */}
      [다음으로]를 누르면 이어지는 조사로 넘어갑니다.
      <div className="link-buttons">
        <Link
          to={`/token/${token}/survey/${prevSurveyType}/${prevSurveyNumber}/${prevTopicNumber}/${prevScreenNumber}`}
          className="link-btn"
          alt="뒤로 버튼"
        >
          뒤로
        </Link>
        <Link
          to={`/token/${token}/intro/${nextSurveyType}/${
            prevSurveyNumber + 1
          }/0/0`}
          className="link-btn"
          alt="다음으로 버튼"
        >
          다음으로
        </Link>
      </div>
    </div>
  );
};

export default Separator;
